<template>
  <div class="mobile-contactUs flex-col align-center">
    <Nav />
    <div class="content">
      <div class="form-content flex-col align-center">
        <h4 class="form-title">联系我们</h4>
        <h6 class="form-describe">
          加入我们，与我们共同创造一个温馨、安全、充满活力的社交环境。
        </h6>
        <form id="contact-form" class="formbox" novalidate>
          <input
            type="text"
            v-model="name"
            name="name"
            placeholder="你的昵称"
            class="inputbox"
          />
          <input
            class="inputbox"
            v-model="email"
            type="text"
            name="email"
            placeholder="你的邮箱"
            @change="validateEmail"
            required
          />
          <textarea
            v-model="message"
            class="textareabox"
            name="message"
            placeholder="你的反馈或建议内容"
            @input="adjustSize"
            required
          ></textarea>
          <button
            type="submit"
            v-if="!loading && name && email && message"
            class="submitClass"
          >
            <span>提交</span>
          </button>
          <div class="submitDis" v-else-if="loading && name && email && message">
            <span>提交中</span>
          </div>
          <div class="submitDis" v-else>
            <span>提交</span>
          </div>
        </form>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Nav from "./components/Nav";
import Footer from "./components/Footer";
export default {
  name: "MobileConnectUs",
  components: {
    Nav,
    Footer,
  },
  data() {
    return {
      name: "",
      email: "",
      message: "",
      loading: false
    };
  },
  mounted() {
    // Initialize EmailJS
    emailjs.init("lCvE3WOqbqiit3J3q"); // Replace with your EmailJS user ID

    function debounce(func, wait) {
      let timeout;
      return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(context, args);
        }, wait);
      };
    }
    const submitFormDebounced = debounce((event) => {
      event.preventDefault();
      // Send the form data using EmailJS
      emailjs
        .sendForm("service_2pg3jeh", "template_zh4de9a", event.target)
        .then(() => {
          this.loading = false
          this.$message({
            message:"邮件发送成功！",
            type: "success",
            center: true,
            customClass: "mobile-message-box",
          });
          // event.target.reset();
        })
        .catch((error) => {
          this.$message({
            message:"邮件发送失败，请重试！",
            type: "warning",
            center: true,
            customClass: "mobile-message-box",
          });
        });
    }, 500); // 设置延迟时间为 500 毫秒
    // Form submission handling
    document
      .getElementById("contact-form")
      .addEventListener("submit", (event) => {
        event.preventDefault();
        this.loading = true
        submitFormDebounced(event);
      });
  },
  methods: {
    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const isValid = emailRegex.test(this.email);
      if (!isValid) {
        this.$message({
          message: "邮箱格式无效！",
          center: true,
          type: "warning",
          customClass: "mobile-message-box",
        });
        this.email = ''
      }
    },
    adjustSize() {
      this.$nextTick(() => {
        let textarea = this.$el.querySelector('textarea');
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'rem';
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.mobile-contactUs {
  width: 375rem;
  min-height: 100vh;
  margin: 0 auto;
  position: relative;
  padding-top: 50rem;
  background: #F7F7F7;

  .content {
    width: 100%;
    padding: 24rem 16rem 36rem;
    box-sizing: border-box;
    .form-content {
      width: 343rem;
      background: #FFFFFF;
      border-radius: 18rem;
      padding: 28rem 16rem;

      .form-title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 16rem;
        color: #333333;
        line-height: 19rem;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-bottom: 8rem;
      }

      .form-describe {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12rem;
        color: #999999;
        line-height: 14rem;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-bottom: 24rem;
      }

      .formbox {
        .inputbox {
          width: 311rem;
          height: 48rem;
          background: #F9F9F9;
          border-radius: 15rem 15rem 15rem 15rem;
          margin-bottom: 16rem;
          padding: 0 18rem;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14rem;
          color: #333333;
          line-height: 16rem;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .inputbox::placeholder {
          color: #cccccc;
        }

        .textareabox {
          width: 311rem;
          min-height: 128rem;
          max-height: 375rem;
          background: #F9F9F9;
          border-radius: 15rem;
          padding: 18rem;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14rem;
          color: #333333;
          line-height: 16rem;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-bottom: 24rem;
          resize: none;
          overflow-y: auto;
        }

        .textareabox::placeholder {
          color: #cccccc;
        }

        .submitClass {
          width: 311rem;
          height: 48rem;
          background: #333333;
          border-radius: 15rem;
          text-align: center;
          line-height: 48rem;
          span {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14rem;
            text-align: center;
            font-style: normal;
            text-transform: none;
            background-image: linear-gradient(to bottom, #EBFF00, #00F284);
            /* WebKit内核的浏览器专用 */
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            /* 其他浏览器的回退方案 */
            color: #FFFFFF;
          }
        }

        .submitDis {
          width: 311rem;
          height: 48rem;
          background: #CCCCCC;
          border-radius: 15rem;
          text-align: center;
          line-height: 48rem;
          span {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14rem;
            color: #FFFFFF;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }
      }
    }
  }
}
</style>
